
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldCheck, Mail, Info, FileText, Lock, X } from 'lucide-react';
import { useState } from 'react';

const PublicFooter = () => {
    const navigate = useNavigate();
    const [showAbout, setShowAbout] = useState(false);
    const currentYear = new Date().getFullYear();

    return (
        <footer className="w-full bg-white border-t border-gray-100 px-6 py-10 pb-24 mt-10">
            <div className="max-w-md mx-auto space-y-8">
                {/* Segurança */}
                <div className="flex items-center space-x-4 p-4 bg-blue-50 rounded-2xl">
                    <ShieldCheck className="text-blue-600 shrink-0" size={24} />
                    <div className="text-left">
                        <p className="text-[10px] font-black text-blue-600 uppercase tracking-widest">Plataforma Segura</p>
                        <p className="text-[10px] text-blue-800 font-bold leading-tight">Criptografia de ponta a ponta e verificação de profissionais.</p>
                    </div>
                </div>

                {/* Links Legais */}
                <div className="grid grid-cols-2 gap-4">
                    <button
                        onClick={() => navigate('/termos/cliente')}
                        className="flex items-center space-x-2 text-gray-500 hover:text-blue-600 transition-colors"
                    >
                        <FileText size={14} />
                        <span className="text-[10px] font-black uppercase tracking-widest">Termos</span>
                    </button>
                    <button
                        onClick={() => navigate('/privacidade')}
                        className="flex items-center space-x-2 text-gray-500 hover:text-blue-600 transition-colors"
                    >
                        <Lock size={14} />
                        <span className="text-[10px] font-black uppercase tracking-widest">Privacidade</span>
                    </button>
                    <button
                        onClick={() => setShowAbout(true)}
                        className="flex items-center space-x-2 text-gray-500 hover:text-blue-600 transition-colors"
                    >
                        <Info size={14} />
                        <span className="text-[10px] font-black uppercase tracking-widest">Sobre Nós</span>
                    </button>
                    <a
                        href="mailto:suporte@tservi.com.br"
                        className="flex items-center space-x-2 text-gray-500 hover:text-blue-600 transition-colors"
                    >
                        <Mail size={14} />
                        <span className="text-[10px] font-black uppercase tracking-widest">Suporte</span>
                    </a>
                </div>

                {/* Mensagem Final */}
                <div className="text-center space-y-4 pt-4">
                    <p className="text-[10px] font-black text-gray-300 uppercase tracking-[0.3em]">T-SERVI © {currentYear}</p>
                    <p className="text-[9px] font-black uppercase tracking-widest text-gray-400 opacity-80">
                        Jesus é o Caminho, a Verdade e a Vida
                    </p>
                </div>
            </div>

            {/* Modal Sobre Nós */}
            {showAbout && (
                <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[150] flex items-center justify-center p-6 animate-fade-in">
                    <div className="bg-white rounded-[2.5rem] p-8 max-w-sm w-full relative shadow-2xl">
                        <button onClick={() => setShowAbout(false)} className="absolute top-6 right-6 text-gray-400 p-2 hover:bg-gray-100 rounded-full transition-colors"><X size={20}/></button>

                        <div className="text-left">
                            <h3 className="text-lg font-black text-gray-800 uppercase tracking-tighter mb-4">Sobre a T-SERVI</h3>
                            <div className="space-y-4">
                                <p className="text-xs text-gray-600 font-bold leading-relaxed">
                                    A T-SERVI nasceu para simplificar o encontro entre quem precisa de ajuda e quem sabe fazer.
                                </p>
                                <p className="text-xs text-gray-600 font-bold leading-relaxed">
                                    Somos uma plataforma em fase beta, focada em valorizar o trabalho autônomo local e oferecer ferramentas seguras para que o pequeno empreendedor possa crescer.
                                </p>
                                <div className="space-y-3 bg-gray-50 p-4 rounded-2xl border border-gray-100">
                                    <h4 className="text-[10px] font-black text-gray-800 uppercase tracking-widest">Transparência T-SERVI</h4>
                                    <div className="flex items-center space-x-2">
                                        <div className="w-1.5 h-1.5 bg-blue-500 rounded-full"></div>
                                        <p className="text-[10px] text-gray-600 font-bold">Clientes: Uso 100% Gratuito.</p>
                                    </div>
                                    <div className="flex items-center space-x-2">
                                        <div className="w-1.5 h-1.5 bg-blue-500 rounded-full"></div>
                                        <p className="text-[10px] text-gray-600 font-bold">Profissionais: Taxa fixa de 10% sobre serviços fechados.</p>
                                    </div>
                                    <div className="flex items-center space-x-2">
                                        <div className="w-1.5 h-1.5 bg-blue-500 rounded-full"></div>
                                        <p className="text-[10px] text-gray-600 font-bold">Pagamentos: Diretos via PIX ou dinheiro (Não processamos valores).</p>
                                    </div>
                                </div>
                                <div className="p-4 bg-blue-50 rounded-2xl border border-blue-100">
                                    <p className="text-[10px] text-blue-700 font-black italic text-center">
                                        "Acreditamos que o trabalho honesto transforma vidas e aproxima pessoas."
                                    </p>
                                </div>
                            </div>
                        </div>

                        <button
                            onClick={() => setShowAbout(false)}
                            className="mt-8 w-full py-4 bg-blue-600 text-white font-black uppercase text-xs rounded-2xl shadow-lg active:scale-95 transition-all"
                        >
                            Entendi
                        </button>
                    </div>
                </div>
            )}
        </footer>
    );
};

export default PublicFooter;
